import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/tarifs/_components/MobilePricingCard.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/tarifs/_components/PaymentSubscriptionButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/tarifs/_components/PricingCardSections.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/tarifs/_components/TestimonialCarousel.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/landing/NavLanding.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/NewsletterForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/TrustSponsor.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/CWFSwitch.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
